import { Card } from "primereact/card";
import { registerSectionType } from "../../utils/sectionRegistry";
import { Section, renderImage, renderCtaButton } from "../sectionHelpers";
import "../../styles/section-styles.css";

registerSectionType({
  type: "tarjetasAccion",
  label: "Tarjetas",
  layout: "cards",
  previewBlocks: ["Tarjeta + boton", "Tarjeta + boton", "Tarjeta + boton"],
  legacyType: "actionCards",
  getDefaults: () => ({ type: "tarjetasAccion", title: "", description: "", itemsText: "", draft_title: "", draft_subtitle: "", draft_button: "", draft_link: "", draft_image: "" }),
  editorFields: [
    { key: "title", label: "Titulo de la tarjeta" },
    { key: "subtitle", label: "Subtitulo de la tarjeta" },
    { key: "button", label: "Texto del boton" },
    { key: "link", label: "Ruta del boton" },
    { key: "image", label: "Imagen de la tarjeta", placeholder: "https://..." },
  ],
  itemLabel: "tarjeta",
  render: (section, index) => {
    const items = Array.isArray(section?.items) ? section.items : [];
    return (
      <Section section={section} keyName={`action-cards-${index}`}>
        <div className="dynamic-grid dynamic-grid-action-cards">
          {items.map((item, idx) => {
            const hasImage = !!item?.image?.src;
            const cardHeader = hasImage
              ? <div className="dynamic-action-card-image-header">{renderImage(item.image.src, item.image.alt || item.title || "Imagen")}</div>
              : item?.icon
              ? (
                <div className="dynamic-action-card-icon-header">
                  <div className="dynamic-action-card-icon-wrapper"><i className={item.icon} /></div>
                </div>
              )
              : null;
            return (
              <Card
                key={`${item?.title || "action"}-${idx}`}
                header={cardHeader}
                title={item?.title || ""}
                className={`tarjetasaccion-card ${hasImage ? "has-image" : item?.icon ? "has-icon" : "no-media"}`}
                footer={renderCtaButton(item?.button)}
                pt={{
                  body: { className: "tarjetasaccion-body" },
                  title: { className: "tarjetasaccion-title" },
                  content: { className: "tarjetasaccion-content" },
                  footer: { className: "tarjetasaccion-footer" },
                }}
              >
                {item?.subtitle ? <p className="dynamic-action-card-subtitle">{item.subtitle}</p> : null}
                {item?.description ? <p className="dynamic-action-card-description">{item.description}</p> : null}
              </Card>
            );
          })}
        </div>
      </Section>
    );
  },
});
